import { useCallback, useState } from 'react';
import {
  loadPoBalanceWarnings,
  type LoadPoBalanceWarningsInput,
  type PoBalanceWarning,
} from '../utils/poBalanceWarning';

/**
 * Submit-time PO remaining-balance check. Returns false when a warning modal
 * should open; the caller must not block submit after the user confirms.
 */
export function usePoBalanceWarning() {
  const [warnings, setWarnings] = useState<PoBalanceWarning[] | null>(null);
  const [checking, setChecking] = useState(false);

  const check = useCallback(async (input: LoadPoBalanceWarningsInput): Promise<boolean> => {
    setChecking(true);
    try {
      const found = await loadPoBalanceWarnings(input);
      if (found.length > 0) {
        setWarnings(found);
        return false;
      }
      return true;
    } catch (error) {
      console.error('Failed to check PO remaining balance', error);
      return true;
    } finally {
      setChecking(false);
    }
  }, []);

  const dismiss = useCallback(() => setWarnings(null), []);

  return { warnings, checking, check, dismiss };
}
